import { isFeatureOn, whitelabel } from '../../../../whitelabel';
import { Features } from '@zignaly-open/ps2-definitions';
import { MarketplaceService } from '../../../../apis/marketplace/types';

export function isServiceOkToShow(s: MarketplaceService) {
  return (
    !isFeatureOn(Features.ZScore) ||
    !whitelabel.marketplaceMinScore ||
    whitelabel.marketplaceMinScore <= s.zscore
  );
}
